import { useEffect, useState } from 'react'
import { LeaveRequestSource } from '../../../../database/enums/LeaveRequestSource.enum'
import { FetchStatus } from '../../../../types/fetch-status.types'
import constants from '../../../../constants'
import LeaveRequestService from '../../../../services/leave-request'
import { LeaveRequest } from '../../../../database/tables'
import { GridActionsCellItem, GridColDef, GridRowParams } from '@mui/x-data-grid'
import { LeaveTime } from '../../../../database/enums/LeaveTime.enum'
import LeaveTimeEnumHelper from '../../../../database/enums/helpers/leave-time.helper'
import { LeaveType } from '../../../../database/enums/LeaveType.enum'
import LeaveTypeEnumHelper from '../../../../database/enums/helpers/leave-type.helper '
import { AccountTeam } from '../../../../database/enums/AccountTeam.enum'
import AccountTeamEnumHelper from '../../../../database/enums/helpers/account-team.helper'
import { ApprovalStatus } from '../../../../database/enums/ApprovalStatus.enum'
import ApprovalStatusEnumHelper from '../../../../database/enums/helpers/approval-status.helper'
import InfoIcon from '@mui/icons-material/Info'
import links from '../../../../routes/links'
import { useNavigate } from 'react-router'
import IconEdit from '@mui/icons-material/Edit'

const { smallActionWidth, defaultBaseWidth, defaultDateTimeWidth, defaultDateWidth } = constants.dataGrid
export const scopeNamePrefix = 'admin-leave-requests-responded-japan'

export default function useAdminLeaveRequestsJapanPageViewModel() {
  const navigate = useNavigate()

  const [dataFetchStatus, setDataFetchStatus] = useState<FetchStatus>(constants.fetchStatus.default)
  const [leaveRequests, setLeaveRequests] = useState<LeaveRequest[]>([])

  const tableColumns: GridColDef<LeaveRequest>[] = [
    {
      field: 'approvalStatus',
      headerName: 'Status',
      minWidth: defaultBaseWidth,
      type: 'singleSelect',
      valueOptions: Object.values(ApprovalStatus),
      getOptionLabel: value => ApprovalStatusEnumHelper.getLabel(value as ApprovalStatus),
    },
    { field: 'name', headerName: 'Name', editable: true, minWidth: defaultBaseWidth, type: 'string' },
    { field: 'email', headerName: 'Email', editable: true, minWidth: defaultBaseWidth, type: 'string' },
    {
      field: 'accountTeam',
      headerName: 'Team',
      minWidth: defaultBaseWidth,
      type: 'singleSelect',
      valueOptions: Object.values(AccountTeam),
      getOptionLabel: value => AccountTeamEnumHelper.getLabel(value as AccountTeam),
    },
    { field: 'position', headerName: 'Position', editable: true, minWidth: defaultBaseWidth, type: 'string' },
    { field: 'startDate', headerName: 'Start Date', editable: true, minWidth: defaultDateWidth, type: 'date' },
    { field: 'endDate', headerName: 'End Date', editable: true, minWidth: defaultDateWidth, type: 'date' },
    {
      field: 'leaveTime',
      headerName: 'Time',
      minWidth: defaultDateWidth,
      type: 'singleSelect',
      valueOptions: Object.values(LeaveTime),
      getOptionLabel: value => LeaveTimeEnumHelper.getLabel(value as LeaveTime),
    },
    {
      field: 'leaveType',
      headerName: 'Type',
      flex: 1,
      minWidth: defaultBaseWidth,
      type: 'singleSelect',
      valueOptions: Object.values(LeaveType),
      getOptionLabel: value => LeaveTypeEnumHelper.getLabel(value as LeaveType),
    },
    { field: 'otherLeaveType', headerName: 'Other Type', editable: true, minWidth: defaultBaseWidth, type: 'string' },
    { field: 'reason', headerName: 'Reason', editable: true, minWidth: defaultBaseWidth, type: 'string' },
    { field: 'createdAt', headerName: 'Created At', editable: true, minWidth: defaultDateTimeWidth, type: 'dateTime' },
    {
      field: 'actions',
      headerName: 'Actions',
      width: smallActionWidth,
      type: 'actions',
      getActions: (params: GridRowParams<LeaveRequest>) => [
        <GridActionsCellItem
          key={`${scopeNamePrefix}-table-actions-${params.id}-info`}
          icon={<InfoIcon color='info' />}
          label='Info'
          onClick={() => navigate(links.admin.leaveRequestDetail({ id: params.row.id }))}
        />,
        <GridActionsCellItem
          key={`${scopeNamePrefix}-table-actions-${params.id}-edit`}
          icon={<IconEdit color='warning' />}
          label='Edit'
          onClick={() => navigate(links.admin.leaveRequestEdit({ id: params.row.id }))}
        />,
      ],
    },
  ]

  async function fetchLeaveRequestsRespondedData() {
    setDataFetchStatus({ ...constants.fetchStatus.default, isLoading: true })
    await LeaveRequestService.getResponded({ source: LeaveRequestSource.JAPAN })
      .then(res => {
        setLeaveRequests(res)
        setDataFetchStatus({ ...constants.fetchStatus.default, isSuccess: true })
      })
      .catch(error => {
        console.log(error)
        setDataFetchStatus({ ...constants.fetchStatus.default, isError: true })
      })
  }

  useEffect(() => {
    fetchLeaveRequestsRespondedData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    dataFetchStatus,
    fetchLeaveRequestsRespondedData,
    tableData: {
      columns: tableColumns,
      rows: leaveRequests,
    },
  }
}
